import {
  getData,
  postData 
} from './api-base.service'


export const getAdvertitings = () => {
  return getData('/Advertisting/GetAdvertistings');  
}

export const disable=(id)=>{
  return postData('/Advertisting/DisableAdvertisting?id='+id); 
}

export const enable=(id)=>{
  return postData("/Advertisting/EnableAdvertisting?id="+id);
}

export const deleteIt=(id)=>{
  return postData("/Advertisting/DeleteAdvertisting?id="+id);
}

export const edit=(model)=>{
  let m={
    pictureUrl:model.pictureUrl,
    linkUrl:model.linkUrl,
    isActive:model.isActive,
    id:model.id
  }
  return postData("/Advertisting/EditAdvertisting",m);
}

export const add=(model)=>{
  let m={
    pictureUrl:model.pictureUrl,
    linkUrl:model.linkUrl,
    isActive:model.isActive
  }
  return postData("/Advertisting/AddAdvertisting",m);
}







// WEBPACK FOOTER //
// ./src/service/advertisting.service.js